import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

import { CardItemList } from 'components/Card'
import { Modal } from 'components/Modal'
import { Form, Checkbox } from 'components/forms'
import { DateIntervalForm } from 'components/shared/DateIntervalForm'
import Button from 'components/Button'
import Divider from 'components/Divider'
import localDateFormatter from 'helpers/localDateFormatter'

const Periods = ({ value, onChange }) => {
	const [modal, setModal] = useState()
	const [t, language] = useTranslation()
	const initPeriod = { from: moment().utc().startOf('day').toISOString(), to: moment().utc().endOf('day').toISOString() }
	const initWeekDays = Array(7).fill(true)
	const renderWeekDays = useCallback(() => {
		const daysArr = [[], [], []]
		const labelsArr = [t('common.dates.monday'), t('common.dates.tuesday'), t('common.dates.wednesday'),
			t('common.dates.thursday'), t('common.dates.friday'), t('common.dates.saturday'), t('common.dates.sunday')]
		initWeekDays.forEach((item, i) => {
			const checkbox = (
				<Checkbox
					key={i}
					field={`weekDays[${i}]`}
					label={labelsArr[i]}
				/>)
			if(i < 3) {
				daysArr[0].push(checkbox)
			} else if(i >= 3 && i < 5) {
				daysArr[1].push(checkbox)
			} else {
				daysArr[2].push(checkbox)
			}
		})
		return(
			<Row>
				<Col xs={4}>{daysArr[0]}</Col>
				<Col xs={4}>{daysArr[1]}</Col>
				<Col xs={4}>{daysArr[2]}</Col>
			</Row>
		)
	}, [initWeekDays])

	const handleSubmit = ({ period: { from, to }, weekDays }) => {
		const intervals = []
		const isAllWeek = !weekDays.some(item => !item)
		const momentFrom = moment(from)
		const momentTo = moment(to)
		const periodDays = momentTo.diff(momentFrom, 'days')
		for(let i = 0; i <= periodDays; i++) {
			const curDate = momentFrom.clone().add(i, 'days')
			const weekDayInd = curDate.isoWeekday() - 1
			const addInterval = isAllWeek ? true : weekDays[weekDayInd]
			if(addInterval) {
				intervals.push({ from: curDate.toISOString(), to: curDate.add(1, 'days').toISOString() })
			}
		}
		if(intervals.length) {
			onChange([...value, ...intervals])
		}
		setModal(false)
	}

	return(
		<>
			<CardItemList
				items={value || []}
				ItemComponent={({ item }) => localDateFormatter({ date: item?.from, language }) || null}
				onAddItem={() => setModal(true)}
				onRemoveItem={item => onChange(value.filter(({ from }) => from !== item?.from))}
				onRemoveAll={() => onChange([])}
				label={t('statistic_section.strings.separate_days')}
				height={200}
				styleInverted
			/>
			{modal &&
				<Modal unmount={() => setModal(false)} label={t('common.strings.date_period')} width={500}>
					<Form
						initialValues={{ period: initPeriod, weekDays: initWeekDays }}
						onSubmit={handleSubmit}
					>
						<DateIntervalForm maxDate={moment().utc()} />
						<Divider visible />
						{renderWeekDays()}
						<Divider />
						<Button type='submit' text={t('common.buttons.apply')} />
					</Form>
				</Modal>
			}
		</>
	)
}

Periods.propTypes = {
	onChange: PropTypes.func.isRequired,
	value: PropTypes.array
}

export default Periods
